import t from"react";var e=t.createContext({orientation:"horizontal",imagesLessThanSlidesToShow:!1}),o=function(){return t.useContext(e)};export{e as ThumbnailsContext,o as useThumbnailsContext};
